import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function DeactivateButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Deactivate
    </Button>
  );
}
